import api from '../api/axios';

function buildTrackingParams({ userId, teamLeadId, recruiterId, from, to }) {
  const params = { userId };
  if (teamLeadId) params.teamLeadId = teamLeadId;
  if (recruiterId) params.recruiterId = recruiterId;
  if (from) params.from = from;
  if (to) params.to = to;
  return params;
}

export const getTrackingSummary = (filters) =>
  api.get('/api/tracking/summary', { params: buildTrackingParams(filters) }).then((r) => r.data);

export const getStageCandidates = (stageKey, filters) =>
  api
    .get(`/api/tracking/stages/${stageKey}/candidates`, { params: buildTrackingParams(filters) })
    .then((r) => r.data);
